import { render, staticRenderFns } from "./TakeExam.vue?vue&type=template&id=f8b97ac2&scoped=true"
import script from "./TakeExam.vue?vue&type=script&lang=js"
export * from "./TakeExam.vue?vue&type=script&lang=js"
import style0 from "./TakeExam.vue?vue&type=style&index=0&id=f8b97ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b97ac2",
  null
  
)

export default component.exports